import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { parse, stringify } from '../util/urlHelpers';
import { HELP_QUERY_PARAM } from '../util/userTypeRedirects';
import { useHelpFlyout } from './helpFlyoutContext';

/**
 * Opens HelpFlyout from ?help=<contentId>, then strips the param so refresh
 * does not reopen forever.
 */
export const HelpFlyoutUrlSync = () => {
  const { openHelp } = useHelpFlyout();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = parse(location.search);
    const helpId = params[HELP_QUERY_PARAM];
    if (!helpId || typeof helpId !== 'string') {
      return;
    }

    openHelp(helpId);

    const nextParams = { ...params };
    delete nextParams[HELP_QUERY_PARAM];
    const nextSearch = stringify(nextParams);
    history.replace({
      pathname: location.pathname,
      search: nextSearch ? `?${nextSearch}` : '',
      hash: location.hash,
      state: location.state,
    });
  }, [history, location.hash, location.pathname, location.search, location.state, openHelp]);

  return null;
};

export default HelpFlyoutUrlSync;
